module.exports = __webpack_public_path__ + "media/images/ibm-logo-fe85ffd57d9d2eb814dd76376674c7a3.svg";